export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const REFRESH_TOKEN = '/token/refresh'
export const FORGOT_PASSWORD = '/forgot_password/'